import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { getUserLanguage } from "../utils/languageUtils";

// Import translation files
import en from "./locales/en.json";
import zh from "./locales/zh.json";
import es from "./locales/es.json";

const resources = {
  en: {
    translation: en,
  },
  zh: {
    translation: zh,
  },
  es: {
    translation: es,
  },
};

// Initialize i18n without setting language immediately
// Language will be set after API call to get fresh user data
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    // lng: getUserLanguage() || "en", // Default to English, will be updated after API call
    fallbackLng: "en",
    debug: process.env.NODE_ENV === "development",

    interpolation: {
      escapeValue: false, // React already does escaping
    },

    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
    },
  });

export default i18n;
